import getApiClient from '@/plugins/api-client'
import Vue from 'vue'

export default {
  load () {
    const api = getApiClient(this.$store)
    const id = this.$route.params.id

    api.get(`redirects/${id}`)
      .then(result => {
        this.redirect = result.data
        this.postList = [result.data.post]
      })
      .catch(error => {
        this.error = error.response
      })
  },

  save () {
    this.errors = {}
    const api = getApiClient(this.$store)
    const method = this.redirect.id ? 'patch' : 'post'
    const options = {}

    let endpoint = 'redirects'

    const payload = this.redirect

    if (method === 'patch') {
      options.headers = {
        'Content-Type': 'application/merge-patch+json',
      }
      endpoint = this.redirect['@id']
      payload.post = this.redirect.post['@id']
    }

    api[method](endpoint, payload, options)
      .then(() => {
        this.$store.commit('app/raiseSuccess', 'Redirecionamento salvo com sucesso')
        this.$router.push({
          name: 'Redirects',
        })
      })
      .catch(error => {
        if (error.response.status === 422) {
          this.parseErrors(error.response.data)
        }
        this.$store.commit('app/raiseError', 'Falha ao salvar redirecionamento')
      })
  },

  parseErrors (errors) {
    const self = this

    errors.violations.forEach(violation => {
      Vue.set(self.errors, violation.propertyPath, violation.message)
    })
  },

  searchPosts (query) {
    const api = getApiClient(this.$store)

    const params = {
      title: query,
    }

    api.get('posts', { params })
      .then(result => {
        this.postList = result.data['hydra:member']
      })
      .catch(() => {
        return false
      })
  },
}
